module.exports = __webpack_public_path__ + "img/icon-x.7799e8dd.svg";